'use strict';

angular.module('userRequestEditControllers')

.controller('MoreInfosController', ['$scope', 'editAccessRequestService', function ($scope, editAccessRequestService) {

    var dontProcessBefore = $scope.userRequest.DontProcessBefore;
    if (!_.isUndefined(dontProcessBefore) && dontProcessBefore.length > 0) {
        $scope.userRequest.DontProcessBefore = moment(dontProcessBefore).format();
    }

    $scope.supervisorId = $scope.userRequest.ActualSupervisorID;
    $scope.supervisorDelegateId = $scope.userRequest.ApprovedBySupervisorID !== $scope.userRequest.ActualSupervisorID ? $scope.userRequest.ApprovedBySupervisorID : null;

    $scope.updateInfos = function () {
        $scope.userRequest.NoSdeLink = true;

        editAccessRequestService.request.updateInfos($scope.userRequest.UserAccessRequestID,
                                                     $scope.userRequest.Comments,
                                                     $scope.userRequest.DontProcessBefore,
                                                     $scope.userRequest.AdminTicketNumber)
        .then(function () {
        });
    }
}]);
